import './redefine.js';
import { r as redefine$1 } from '../../../../../../_virtual/redefine.js';

var redefine = redefine$1.exports;

var redefineAll = function (target, src, options) {
  for (var key in src) redefine(target, key, src[key], options);

  return target;
};

export { redefineAll as default };
